export default class EvaluatorPaymentActionParamsItem {
    constructor(ids, allItemsInTheSearchSetAreSelected = false, searchItem = null) {
        this.Ids = ids;
        this.Reason = "";
        this.Surcharge = 0;
        this.AllItemsInTheSearchSetAreSelected = allItemsInTheSearchSetAreSelected;
        this.SearchItem = searchItem;
        this.Command = "";
    }
}
